// extracted by mini-css-extract-plugin
export default {"User":"CalEvent_User__fek8B"};